export const environment = {
  appName: 'CurierNow QA',
  production: false,
  gtmId: 'GTM-KK57QJ2H',
  gtmAuth: '3iIoAo8YK61cruCfvJvHfA',
  gtmPreview: 'env-5',
};
